type ComputedStyles = {
  [key: string]: React.CSSProperties;
}

export const getStyles = (): ComputedStyles => ({
  banner: {
    minHeight: '4rem',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    textDecoration: 'none',
  },
  text: {
    color: 'inherit',
    fontSize: '1.125rem',
    fontWeight: 600,
    textAlign: 'center',
    lineHeight: 1.5,
  },
  link: {
    fontWeight: 700,
    textDecoration: 'underline',
  },
  dismiss: {
    height: '100%',
    margin: 0,
    padding: 0,
    marginLeft: '1rem',
    fontSize: '2rem',
    border: 'none',
    outline: 'none',
    boxShadow: 'none',
    backgroundColor: 'transparent',
    cursor: 'pointer',
  },
});
